<template>
    <p class="field">
        <label :for="label">{{ label }}</label>
        <slot />
    </p>
</template>

<script>
export default {
    name: 'app-table-header-select',
    props: {
        label: {
            type: String,
            default: ''
        }
    }
}
</script>